import React from 'react';
import { DatePicker, Modal, Select } from 'antd'
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;

// // 限制日期的范围选择
// const disabledDate = (current) => {
//     //   筛选范围限制
//     return current < moment('2022-05-01') || current > moment('2024-01-01');
// };
export const relate_cols = [
    {
        title: '票据号码',
        en_title: 'Ticket number',
        ch_title: '票据号码',
        dataIndex: '票据号码',
    },
    {
        title: '开立日',
        en_title: 'Issuance date',
        ch_title: '开立日',
        dataIndex: '开立日',
    },
    {
        title: '票据名称',
        en_title: 'Ticket name',
        ch_title: '票据名称',
        dataIndex: '票据名称',
    },
    {
        title: '票据金额',
        en_title: 'Ticket amount',
        ch_title: '票据金额',
        dataIndex: '票据金额',
    },
    {
        title: '捐款项目',
        en_title: 'Donation items',
        ch_title: '捐款项目',
        dataIndex: '捐款项目',
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
    },
    {
        title: '志工编号',
        en_title: 'Commissioner No.',
        ch_title: '志工编号',
        dataIndex: '志工编号',
    },
    {
        title: '志工姓名',
        en_title: 'Commissioner Name',
        ch_title: '志工姓名',
        dataIndex: '志工姓名',
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号码',
        en_title: 'phone number',
        ch_title: '手机号码',
        dataIndex: '手机号码',
    },
    {
        title: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
        dataIndex: '邮箱',
    },
    {
        title: '作废原因',
        en_title: 'Reason for red invoices',
        ch_title: '作废原因',
        dataIndex: '作废原因',
    },
]
export const batch_cols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号'
    },
    {
        title: '票据号码',
        en_title: 'Ticket number',
        ch_title: '票据号码',
        dataIndex: '票据号码',
    },
    {
        title: '作废原因',
        en_title: 'Reason for red invoices',
        ch_title: '作废原因',
        dataIndex: '作废原因',
    },
    {
        title: '关联号码',
        en_title: 'Related number',
        ch_title: '关联号码',
        dataIndex: '关联号码',
    },
    {
        title: '开立日',
        en_title: 'Issuance date',
        ch_title: '开立日',
        dataIndex: '开立日',
    },
    {
        title: '票据名称',
        en_title: 'Ticket name',
        ch_title: '票据名称',
        dataIndex: '票据名称',
    },
    {
        title: '票据金额',
        en_title: 'Ticket amount',
        ch_title: '票据金额',
        dataIndex: '票据金额',
    },
    {
        title: '捐款项目',
        en_title: 'Donation items',
        ch_title: '捐款项目',
        dataIndex: '捐款项目',
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
    },
    {
        title: '志工编号',
        en_title: 'Commissioner No.',
        ch_title: '志工编号',
        dataIndex: '志工编号',
    },
    {
        title: '志工姓名',
        en_title: 'Commissioner Name',
        ch_title: '志工姓名',
        dataIndex: '志工姓名',
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号码',
        en_title: 'phone number',
        ch_title: '手机号码',
        dataIndex: '手机号码',
    },
    {
        title: '地址',
        en_title: 'Address',
        ch_title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        dataIndex: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
    },
]

const Cols = [
    {
        title: '票据号码',
        en_title: 'Ticket number',
        ch_title: '票据号码',
        dataIndex: '票据号码',
        width: '120px',
    },
    {
        title: '开立日',
        en_title: 'Issuance date',
        ch_title: '开立日',
        dataIndex: '开立日',
        width: '120px'
    },
    {
        title: '票据名称',
        en_title: 'Ticket name',
        ch_title: '票据名称',
        dataIndex: '票据名称',
        width: '120px',
    },
    {
        title: '票据金额',
        en_title: 'Ticket amount',
        ch_title: '票据金额',
        dataIndex: '票据金额',
        width: '90px',
    },
    {
        title: '捐款项目',
        en_title: 'Donation items',
        ch_title: '捐款项目',
        dataIndex: '捐款项目',
        width: '90px',
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
        width: '90px',
    },
    {
        title: '票据号段',
        en_title: 'Ticket number range',
        ch_title: '票据号段',
        dataIndex: '票据号段',
        hideInTable: true,
        hideInDescriptions: true
    },
    {
        title: '志工编号',
        en_title: 'Commissioner No.',
        ch_title: '志工编号',
        dataIndex: '志工编号',
        width: '120px',
    },
    {
        title: '志工姓名',
        en_title: 'Commissioner Name',
        ch_title: '志工姓名',
        dataIndex: '志工姓名',
        width: '120px',
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号码',
        en_title: 'phone number',
        ch_title: '手机号码',
        dataIndex: '手机号码',
        width: '110px',
    },
    {
        title: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
        dataIndex: '邮箱',
        width: '100px',
    },

    //红冲发票字段
    {
        title: '状态',
        en_title: 'Status',
        ch_title: '状态',
        dataIndex: '状态',
        width: '90px',
        render: (text) => {
            return text || '-';
        },
    },
    {
        title: '作废原因',
        en_title: 'Reason for avoid invoices',
        ch_title: '作废原因',
        dataIndex: '作废原因',
        width: '110px',
        render: (text) => {
            return text || '-';
        },
    },
    {
        title: '关联号码',
        en_title: 'Related number',
        ch_title: '关联号码',
        dataIndex: '关联号码',
        render: (text) => {
            return text || '-';
        },
    },
    {
        title: '備註',
        en_title: 'Remark',
        ch_title: '備註',
        dataIndex: '备注',
        render: (text) => {
            return text || '-';
        },
    },
    // {
    //     title: '原票日期',
    //     en_title: 'Original invoice date',
    //     ch_title: '原票日期',
    //     dataIndex: '原票日期',
    //     render: (text) => {
    //         return text || '-';
    //     },
    // },
    // {
    //     title: '红冲关联数',
    //     ch_title: '红冲关联数',
    //     en_title: 'Related number of red-invoice transactions',
    //     dataIndex: '红冲关联数',
    //     sorter: (a, b) => {
    //         return a['红冲关联数'] - b['红冲关联数'];
    //     }
    // },

];


//设置筛选栏 @@index
export const donListCol = Cols.map((i, index) => {
    if (index == 1 || index == 2 || index == 4 || index == 5 || index == 7 || index == 8 || index == 9 || index == 15) {
        return i;
    } else {
        // i.renderFormItem = () => { return null };
        i.renderFormItem = () => false;
    }

    return i;
});

// export { donListCol };